import { ProjectCommentModel, ProjectFileModel } from './../../model/CronosModel';
import { Action } from "@ngrx/store";
import { CronosActionTypes } from ".";
import { TeamModel, ProjectModel, ProjectListModel, ProjectTaskModel } from "../../model/CronosModel";

export class CronosListTeamsAction implements Action {
    public type = CronosActionTypes.LIST_TEAMS;
    public teams: Array<TeamModel>;
    public projects: Array<ProjectModel>;
    public actionProjectId: number;
    public actionListId: number;
    public actionTaskId: number;
    public reorderData: ProjectListModel;
    public savedTaskData: ProjectTaskModel;
    public savedCommentData: ProjectCommentModel;
    public savedFileData: ProjectFileModel;
    public savedProjectData: ProjectModel;
    public errorPayload: any;
    constructor(public payload: { clientId: number }) { }
}

export class CronosListProjectsAction implements Action {
    public type = CronosActionTypes.LIST_PROJECTS;
    public teams: Array<TeamModel>;
    public projects: Array<ProjectModel>;
    public actionProjectId: number;
    public actionListId: number;
    public actionTaskId: number;
    public reorderData: ProjectListModel;
    public savedTaskData: ProjectTaskModel;
    public savedCommentData: ProjectCommentModel;
    public savedFileData: ProjectFileModel;
    public savedProjectData: ProjectModel;
    public errorPayload: any;
    constructor(public payload: { userId: number }) { }
}

export class CronosClearErrorsAction implements Action {
    public type = CronosActionTypes.CLEAR_ERRORS;
    public teams: Array<TeamModel>;
    public projects: Array<ProjectModel>;
    public actionProjectId: number;
    public actionListId: number;
    public actionTaskId: number;
    public reorderData: ProjectListModel;
    public savedTaskData: ProjectTaskModel;
    public savedCommentData: ProjectCommentModel;
    public savedFileData: ProjectFileModel;
    public savedProjectData: ProjectModel;
    public errorPayload: any;
    constructor() { }
}

export class CronosReorderAction implements Action {
    public type = CronosActionTypes.REORDER;
    public teams: Array<TeamModel>;
    public projects: Array<ProjectModel>;
    public actionProjectId: number;
    public actionListId: number;
    public actionTaskId: number;
    public reorderData: ProjectListModel;
    public savedTaskData: ProjectTaskModel;
    public savedCommentData: ProjectCommentModel;
    public savedFileData: ProjectFileModel;
    public savedProjectData: ProjectModel;
    public errorPayload: any;
    constructor(public payload: { projectId: number, model: ProjectListModel }) { }
}

export class CronosSaveTaskAction implements Action {
    public type = CronosActionTypes.SAVE_TASK;
    public teams: Array<TeamModel>;
    public projects: Array<ProjectModel>;
    public actionProjectId: number;
    public actionListId: number;
    public actionTaskId: number;
    public reorderData: ProjectListModel;
    public savedTaskData: ProjectTaskModel;
    public savedCommentData: ProjectCommentModel;
    public savedFileData: ProjectFileModel;
    public savedProjectData: ProjectModel;
    public errorPayload: any;
    constructor(public payload: { projectId: number, listId: number, model: ProjectTaskModel }) { }
}

export class CronosRemoveTaskAction implements Action {
    public type = CronosActionTypes.REMOVE_TASK;
    public teams: Array<TeamModel>;
    public projects: Array<ProjectModel>;
    public actionProjectId: number;
    public actionListId: number;
    public actionTaskId: number;
    public reorderData: ProjectListModel;
    public savedTaskData: ProjectTaskModel;
    public savedCommentData: ProjectCommentModel;
    public savedFileData: ProjectFileModel;
    public savedProjectData: ProjectModel;
    public errorPayload: any;
    constructor(public payload: { projectId: number, listId: number, model: ProjectTaskModel }) { }
}

export class CronosSaveCommentAction implements Action {
    public type = CronosActionTypes.SAVE_COMMENT;
    public teams: Array<TeamModel>;
    public projects: Array<ProjectModel>;
    public actionProjectId: number;
    public actionListId: number;
    public actionTaskId: number;
    public reorderData: ProjectListModel;
    public savedTaskData: ProjectTaskModel;
    public savedCommentData: ProjectCommentModel;
    public savedFileData: ProjectFileModel;
    public savedProjectData: ProjectModel;
    public errorPayload: any;
    constructor(public payload: { projectId: number, listId: number, taskId: number, model: ProjectCommentModel }) { }
}

export class CronosSaveFileAction implements Action {
    public type = CronosActionTypes.SAVE_FILE;
    public teams: Array<TeamModel>;
    public projects: Array<ProjectModel>;
    public actionProjectId: number;
    public actionListId: number;
    public actionTaskId: number;
    public reorderData: ProjectListModel;
    public savedTaskData: ProjectTaskModel;
    public savedCommentData: ProjectCommentModel;
    public savedFileData: ProjectFileModel;
    public savedProjectData: ProjectModel;
    public errorPayload: any;
    constructor(public payload: { projectId: number, listId: number, taskId: number, model: ProjectFileModel, file: File }) { }
}

export class CronosSaveProjectAction implements Action {
    public type = CronosActionTypes.SAVE_PROJECT;
    public teams: Array<TeamModel>;
    public projects: Array<ProjectModel>;
    public actionProjectId: number;
    public actionListId: number;
    public actionTaskId: number;
    public reorderData: ProjectListModel;
    public savedTaskData: ProjectTaskModel;
    public savedCommentData: ProjectCommentModel;
    public savedFileData: ProjectFileModel;
    public savedProjectData: ProjectModel;
    public errorPayload: any;
    constructor(public payload: { model: ProjectModel }) { }
}

export type CronosActions = CronosListTeamsAction | CronosListProjectsAction | CronosClearErrorsAction | CronosReorderAction | CronosSaveTaskAction | CronosRemoveTaskAction | CronosSaveCommentAction | CronosSaveFileAction | CronosSaveProjectAction;


// WEBPACK FOOTER //
// ./src/store/action/CronosActions.ts